import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useProjects } from '../../providers/ProjectsProvider';
import SideDrawer from '../../components/common/SideDrawer';
import { Button, Grid } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ProjectCreateUpdateComponent from '../../components/projects/ProjectCreateUpdateComponent';
import NavBreadcrumbs from '../../components/common/NavBreadcrumbs';

function ProjectUpdatePage() {
    const navigate = useNavigate();
    const { projectId } = useParams();
    const { selectedProject, selectedTeam } = useProjects();

    useEffect(() => {
        if (!selectedProject || selectedProject.id !== projectId) {
            navigate('/teams');
        }
    }, []);

    const handleBackNavigation = async () => {
        navigate(-1);
    };

    return (
        <SideDrawer title='Update Project Details'>
            <Grid container alignItems="center" sx={{ marginBottom: '30px' }}>
                <Grid item>
                    <Button
                        variant="text"
                        onClick={handleBackNavigation}
                    >
                        <ArrowBackIosIcon sx={{ marginLeft: '10px' }} />
                    </Button>
                </Grid>

                <NavBreadcrumbs
                    currentPageTitle="Update Project"
                    history={[
                        {
                            title: "Teams",
                            path: "/teams"
                        },
                        {
                            title: "Projects",
                            path: `/team/${selectedTeam._id}/projects`
                        }
                    ]}
                />
            </Grid>
            <ProjectCreateUpdateComponent existingProject={selectedProject} />
        </SideDrawer>
    );
}

export default ProjectUpdatePage;